module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_round-cross-border-bda385edfcb7bf18ab59227c437fafc8.svg";